import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import { useCheckDevice } from '../../../../hooks/UseCheckDevice';
import { PrivateIncentiveLookupTooltip } from '../../../shared/essential-ui/tooltip/ToolTip';
import { Icon } from '../../../style/Icon';
import { Typography } from '../../../style/Typography';
import { PrivateIncentiveLookupIconSpan } from './Style';

type SelectStorePageHeaderPanel = {
  redirectToAdminPanel: () => void;
  redirectToPrivateIncentiveLookup: () => void;
  logout: () => void;
  isAdminUser: boolean;
};

const SelectStorePageHeaderPanel: FC<SelectStorePageHeaderPanel> = (props) => {
  const { isMobileDevice } = useCheckDevice();

  return (
    <Wrapper data-testid='select-dealer-icons-panel'>
      {!isMobileDevice && props.isAdminUser && (
        <>
          <FilledWhiteButton
            data-testid='private-incentive-lookup-button'
            onClick={props.redirectToPrivateIncentiveLookup}
            data-tooltip-id='private-incentive-lookup-tooltip'
            data-tooltip-content={'Private Incentive Lookup'}
          >
            <PrivateIncentiveLookupIconSpan>
              <Icon
                data-testid='private-incentive-lookup-icon'
                type='private-incentive'
                size={20}
              />
            </PrivateIncentiveLookupIconSpan>
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.bold}
              color={theme.palette.toolTipBackground}
            >
              LOOKUP
            </Typography>
          </FilledWhiteButton>
          <PrivateIncentiveLookupTooltip
            id='private-incentive-lookup-tooltip'
            data-tooltip-place='bottom'
            data-testid='private-incentive-lookup-button-tooltip'
          />
          <FilledWhiteButton data-testid='admin-portal-button' onClick={props.redirectToAdminPanel}>
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.bold}
              color={theme.palette.toolTipBackground}
            >
              ADMIN PORTAL
            </Typography>
          </FilledWhiteButton>
        </>
      )}
      <Button data-testid='logout-button' onClick={props.logout}>
        <Typography
          size={theme.typography.h4}
          fontWeight={
            !isMobileDevice
              ? theme.typography.fontWeights.bold
              : theme.typography.fontWeights.semibold
          }
          color={theme.palette.white}
        >
          LOG OUT
        </Typography>
      </Button>
    </Wrapper>
  );
};

export default SelectStorePageHeaderPanel;

const Wrapper = styled.div`
    display: flex;
    height: 30px;
    line-height: 30px;
    letter-spacing .3px;
    margin-right: -10px;
`;

const Button = styled.div`
  padding: 0px 25px;
  border-radius: 15px;
  font-weight: 600;
  text-transform: uppercase;
  transition: 0.3s ease-in-out;
  cursor: pointer;
  &:hover {
    transform: translateY(-3px);
  }
`;

const FilledWhiteButton = styled(Button)`
  background-color: ${(props) => props.theme.palette.white};
  color: ${(props) => props.theme.palette.toolTipBackground};
  border: 0;
  border-radius: 15px;
  padding: 0 20px;
  margin: 0 10px;
`;
